import React from 'react';

const EMBED_LINK = 'https://s3.amazonaws.com/icomoon.io/158286/BitPlayground/style.css';
// dev link:
// const EMBED_LINK = 'https://i.icomoon.io/public/9dc81da9ad/BitPlayground/style.css';

// we could show a warning when an icon is used without embed.
// seems like an overkill

export function EmbedIconSet({ query = 'dqaogs' }: { query: string }) {
	return <link rel="stylesheet" href={`${EMBED_LINK}?${query}`} />;
}
